module.exports = __webpack_public_path__ + "img/digikala.6883066.png";